export default __webpack_public_path__ + "static/media/mq-old.413b037d.svg";